export function integerDivision(a, b) {
  return Math.floor(a / b);
}